import { configureStore, Store } from '@reduxjs/toolkit';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { DEV } from 'application/consts';

import { createAcceptanceAdvancedListener } from './slices/acceptanceAdvancedSlice/acceptanceAdvancedListener';
import { createGlobalPollingListener } from './slices/globalPollingSlice/globalPollingListener';
import rootReducer from './slices';

export const createStore = (apolloClient: ApolloClient<NormalizedCacheObject>): Store => {
  const acceptanceAdvancedListener = createAcceptanceAdvancedListener(apolloClient);
  const globalPollingListener = createGlobalPollingListener(apolloClient);

  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [
            'persist/PERSIST',
            'acceptanceAdvancedSigningProcess/startAcceptanceAdvancedSigning',
            'globalPolling/startGlobalPolling',
          ],
        },
      }).prepend([globalPollingListener.middleware, acceptanceAdvancedListener.middleware]),
    devTools: DEV,
  });

  return store;
};

export * from './slices';
